/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PregnancyPeriodType {
    PREMATURE = 'premature',
    FULL_TERM_PREGNANCY = 'fullTermPregnancy',
}
